import MenuManage from './MenuManage.vue'

MenuManage.install = function(Vue) {
  Vue.component(MenuManage.name, MenuManage)
}

import MenuEdit from './MenuEdit.vue'

MenuEdit.install = function(Vue) {
  Vue.component(MenuEdit.name, MenuEdit)
}

import MenuDetail from './MenuDetail.vue'

MenuDetail.install = function(Vue) {
  Vue.component(MenuDetail.name, MenuDetail)
}

import MenuBtn from './MenuBtn.vue'

MenuBtn.install = function(Vue) {
  Vue.component(MenuBtn.name, MenuBtn)
}

import MenuBtnEdit from './MenuBtnEdit.vue'

MenuBtnEdit.install = function(Vue) {
  Vue.component(MenuBtnEdit.name, MenuBtnEdit)
}

export { MenuManage, MenuEdit, MenuDetail, MenuBtn, MenuBtnEdit }
